import { Box, Grid, Typography } from '@mui/material';
import { FC } from 'react';

import { useMitarbeiterRole } from '../auth/api/auth.hook';
import { MitarbeiterRole } from '../auth/api/types';

import { DashboardAufwaendeQuote } from './DashboardAufwaendeQuote';
import { DashboardAufwaendeStats } from './DashboardAufwaendeStats';
import { DashboardProjects } from './DashboardProjects';

export const Dashboard: FC = () => {
  const loggedInMitarbeiterRole = useMitarbeiterRole();

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Dashboard
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <DashboardProjects />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <DashboardAufwaendeStats />
        </Grid>
        {(loggedInMitarbeiterRole === MitarbeiterRole.ADMIN ||
          loggedInMitarbeiterRole === MitarbeiterRole.INTERN) && (
          <Grid size={12}>
            <DashboardAufwaendeQuote />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
